module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1O0AS"))).then(() => parcelRequire('1iHdE'));